// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-shell {
  display: grid;
  gap: 1.5rem;
  padding: 0.5rem 0;
}

.page-header {
  background: #f4f7fa;
  border: 1px solid #dce4eb;
  border-left: 4px solid #0073e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem 1.5rem;
  padding: 1.25rem 1.5rem;
  border-radius: 6px;
}
.page-header h1 {
  margin: 0;
  font-size: 1.6rem;
  line-height: 1.2;
  font-weight: 700;
  color: #1a2a38;
  letter-spacing: -0.01em;
}
.page-header p {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #56636f;
}

.filters {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}
.filters label {
  display: grid;
  gap: 0.45rem;
}
.filters label span {
  font-size: 0.85rem;
  line-height: 1.3;
  font-weight: 600;
  color: #45515c;
}
.filters label input,
.filters label select {
  border: 1px solid #ccd6dd;
  border-radius: 4px;
  min-height: 2.75rem;
  padding: 0.55rem 0.65rem;
  font-size: 0.95rem;
  line-height: 1.35;
  background: #fff;
}

.table-shell {
  border: 1px solid #d4dde2;
  border-radius: 8px;
  overflow: auto;
  background: #fff;
}

table {
  width: 100%;
  min-width: 780px;
  border-collapse: collapse;
}
table th,
table td {
  padding: 0.9rem 0.8rem;
  border-bottom: 1px solid #e4ebf0;
  text-align: left;
  vertical-align: top;
  line-height: 1.45;
}
table th {
  background: #f4f8fa;
  font-size: 0.78rem;
  font-weight: 700;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
table p {
  margin: 0.3rem 0 0;
  color: #5d6a76;
  font-size: 0.85rem;
  line-height: 1.5;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.actions button {
  border: 1px solid #b6c4cf;
  border-radius: 4px;
  background: #fff;
  min-height: 2.25rem;
  padding: 0.45rem 0.7rem;
  cursor: pointer;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.2;
}
.actions .danger {
  border-color: #d3a2a2;
  color: #8a1f1f;
}

.pager {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  padding: 0.9rem;
}
.pager span {
  color: #5d6a76;
  font-size: 0.88rem;
  line-height: 1.35;
}
.pager div {
  display: flex;
  gap: 0.6rem;
}
.pager button {
  min-height: 2.25rem;
  border: 1px solid #b6c4cf;
  border-radius: 4px;
  padding: 0.4rem 0.75rem;
  background: #fff;
  font-size: 0.84rem;
}

.btn.primary {
  border: 0;
  border-radius: 4px;
  background: #0f6075;
  color: #fff;
  min-height: 2.75rem;
  padding: 0.6rem 1.1rem;
  cursor: pointer;
  font-size: 0.94rem;
  font-weight: 600;
}

@media (max-width: 960px) {
  .page-header {
    flex-direction: column;
    align-items: stretch;
  }
  .btn.primary {
    align-self: flex-start;
  }
}
@media (max-width: 720px) {
  .page-shell {
    gap: 1rem;
  }
  .filters {
    grid-template-columns: 1fr;
  }
  .pager {
    flex-direction: column;
    align-items: stretch;
  }
  .pager div {
    justify-content: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tools/dynamic-forms/dynamic-forms-list-page/dynamic-forms-list-page.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AACF;AACE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AACJ;AAEE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAAJ;;AAIA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AADF;AAGE;EACE,aAAA;EACA,YAAA;AADJ;AAGI;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AADN;AAII;;EAEE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAFN;;AAOA;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAJF;;AAOA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;AAJF;AAME;;EAEE,sBAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAJJ;AAOE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AALJ;AAQE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AANJ;;AAUA;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAPF;AASE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAPJ;AAUE;EACE,qBAAA;EACA,cAAA;AARJ;;AAYA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AATF;AAWE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AATJ;AAYE;EACE,aAAA;EACA,WAAA;AAVJ;AAaE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAXJ;;AAeA;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAZF;;AAeA;EACE;IACE,sBAAA;IACA,oBAAA;EAZF;EAeA;IACE,sBAAA;EAbF;AACF;AAgBA;EACE;IACE,SAAA;EAdF;EAiBA;IACE,0BAAA;EAfF;EAkBA;IACE,sBAAA;IACA,oBAAA;EAhBF;EAmBA;IACE,2BAAA;EAjBF;AACF","sourcesContent":[".page-shell {\n  display: grid;\n  gap: 1.5rem;\n  padding: 0.5rem 0;\n}\n\n.page-header {\n  background: #f4f7fa;\n  border: 1px solid #dce4eb;\n  border-left: 4px solid #0073e6;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem 1.5rem;\n  padding: 1.25rem 1.5rem;\n  border-radius: 6px;\n\n  h1 {\n    margin: 0;\n    font-size: 1.6rem;\n    line-height: 1.2;\n    font-weight: 700;\n    color: #1a2a38;\n    letter-spacing: -0.01em;\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.9rem;\n    line-height: 1.5;\n    color: #56636f;\n  }\n}\n\n.filters {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n\n  label {\n    display: grid;\n    gap: 0.45rem;\n\n    span {\n      font-size: 0.85rem;\n      line-height: 1.3;\n      font-weight: 600;\n      color: #45515c;\n    }\n\n    input,\n    select {\n      border: 1px solid #ccd6dd;\n      border-radius: 4px;\n      min-height: 2.75rem;\n      padding: 0.55rem 0.65rem;\n      font-size: 0.95rem;\n      line-height: 1.35;\n      background: #fff;\n    }\n  }\n}\n\n.table-shell {\n  border: 1px solid #d4dde2;\n  border-radius: 8px;\n  overflow: auto;\n  background: #fff;\n}\n\ntable {\n  width: 100%;\n  min-width: 780px;\n  border-collapse: collapse;\n\n  th,\n  td {\n    padding: 0.9rem 0.8rem;\n    border-bottom: 1px solid #e4ebf0;\n    text-align: left;\n    vertical-align: top;\n    line-height: 1.45;\n  }\n\n  th {\n    background: #f4f8fa;\n    font-size: 0.78rem;\n    font-weight: 700;\n    white-space: nowrap;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n\n  p {\n    margin: 0.3rem 0 0;\n    color: #5d6a76;\n    font-size: 0.85rem;\n    line-height: 1.5;\n  }\n}\n\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n\n  button {\n    border: 1px solid #b6c4cf;\n    border-radius: 4px;\n    background: #fff;\n    min-height: 2.25rem;\n    padding: 0.45rem 0.7rem;\n    cursor: pointer;\n    font-size: 0.82rem;\n    font-weight: 600;\n    line-height: 1.2;\n  }\n\n  .danger {\n    border-color: #d3a2a2;\n    color: #8a1f1f;\n  }\n}\n\n.pager {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.9rem;\n\n  span {\n    color: #5d6a76;\n    font-size: 0.88rem;\n    line-height: 1.35;\n  }\n\n  div {\n    display: flex;\n    gap: 0.6rem;\n  }\n\n  button {\n    min-height: 2.25rem;\n    border: 1px solid #b6c4cf;\n    border-radius: 4px;\n    padding: 0.4rem 0.75rem;\n    background: #fff;\n    font-size: 0.84rem;\n  }\n}\n\n.btn.primary {\n  border: 0;\n  border-radius: 4px;\n  background: #0f6075;\n  color: #fff;\n  min-height: 2.75rem;\n  padding: 0.6rem 1.1rem;\n  cursor: pointer;\n  font-size: 0.94rem;\n  font-weight: 600;\n}\n\n@media (max-width: 960px) {\n  .page-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .btn.primary {\n    align-self: flex-start;\n  }\n}\n\n@media (max-width: 720px) {\n  .page-shell {\n    gap: 1rem;\n  }\n\n  .filters {\n    grid-template-columns: 1fr;\n  }\n\n  .pager {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .pager div {\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
